// @file utility functions related to post drafts
import type { DraftPost, PostColor } from '@@/types'
import { uniqueId } from 'lodash-es'

export function shouldSyncDraftUpdates<E extends number | string | PostColor | undefined | null>({
  newAttributes,
  oldAttributes,
}: {
  newAttributes: E[]
  oldAttributes: E[]
}): boolean {
  // convert undefined into null for comparison
  const normalizedNewAttributes: Array<NonNullable<E> | null> = newAttributes.map((v) => (v == null ? null : v))
  const normalizedOldAttributes: Array<NonNullable<E> | null> = oldAttributes.map((v) => (v == null ? null : v))

  return normalizedNewAttributes.some((value, index) => normalizedOldAttributes[index] !== value)
}

// don't couple cid to c_{id} for drafts. avoid confusion with posts.
export function addDraftCidIfAbsent(postDraft: DraftPost): DraftPost {
  if (postDraft.cid == null) {
    postDraft.cid = uniqueId('c_new')
  }
  return postDraft
}
